<template>
  <div>
    <!-- 仪表盘 -->
    <Echart
      :options="options"
      :id="cdata.id"
      :height="curHeight+'px'"
      :width="curWidth+'px'"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart/echarts5";
import {getSizeByScreen} from '@/utils/index'

export default {
  data() {
    return {
      options: {},
      curHeight:'',
      curWidth:''
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
    width: {
      type: String,
      default: "600",
    },
    height: {
      type: String,
      default: "200",
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          series: [
            {
              type: 'gauge',
              radius:'90%',
              splitNumber:4,//刻度分割段数
              itemStyle: {
                color: '#1890FF',
                opacity:0.85
              },
              center:['50%','60%'],
              progress: {
                show: true,
                width: 12
              },
              axisLine: {
                lineStyle: {
                  width: 12,
                  color:[[1,'#7499DD']]
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                // 刻度分割线
                distance: 2,
                length: 6,
                lineStyle: {
                  width: 2,
                  color: '#1890FF'
                }
              },
              axisLabel: {
                // 仪表盘刻度
                distance: 20,
                color: '#7499DD',
                fontSize: 14
              },
              anchor: {
                //中间箭头
                show: true,
                showAbove: true,
                size: 18,//大圆直径
                itemStyle: {
                  borderWidth: 4,
                  borderColor:'#1890FF',
                  opacity:0.85
                }
              },
              title: {
                show: false
              },
              max:newData.max|| 100,
              detail: {
                formatter:newData.formatter?newData.formatter:'{value}',
                valueAnimation: true,
                fontSize: 26,
                offsetCenter: [0, '70%'],
                color:"#F0F2F5",//数据的颜色
              },
              data:newData.data|| [
                {
                  name:"维修次数",
                  value: 0
                }
              ]
            }
          ]
        };
      },
      immediate: true,
      deep: true,
    },
    curWidth:{
      handler (newData) {
        this.curWidth = this.width;
        //适配代码
        // this.curWidth = getSizeByScreen(this.width);
      },
      immediate: true,
      deep: true
    },
    curHeight:{
      handler (newData) {
        this.curHeight = this.height;
        //适配代码
        // this.curHeight = getSizeByScreen(this.height);
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    console.log(this.cdata)
  },
  methods: {
    
  }
};
</script>